const projects = [
	{
		url: "https://hashnode-uiclone.vercel.app/",
		githubUrl: "https://github.com/saumya66/HashnodeHome-Clone",
		thumbNail:
			"https://user-images.githubusercontent.com/60464414/120117442-dfe72280-c1aa-11eb-9dba-dc8b4afc1144.PNG",
		title: "Hashnode React Clone",
		desc: "A Full React Clone of Hashnode's Home Feed UI built in a day.",
	},
	{
		url: "https://bitbuzz.netlify.app/",
		githubUrl: "https://github.com/saumya66/BitBuzz-SiliconValley",
		thumbNail: "https://miro.medium.com/max/875/1*64Cf_t35SwfpTe6r46AbRA.png",
		title: "BitBuzz",
		desc: "Bibuzz constantly fetches the rate of Bitcoin and produces sound when it dips.",
	},
	{
		url: "https://songup.netlify.app/",
		githubUrl: "https://github.com/saumya66/SongUp---Full-Stack",
		thumbNail:
			"https://user-images.githubusercontent.com/60464414/120117257-d7421c80-c1a9-11eb-8c97-84354a1dfd19.PNG",
		title: "Song Up",
		desc: "A Full Stack Webapp with features like JWT Authentication & Song Upload built in a day for a Coding Interview.",
	},
	{
		url: "https://saumya66.netlify.app",
		githubUrl: "https://github.com/saumya66/PortfolioSite",
		thumbNail:
			"https://lh3.googleusercontent.com/-nJ2AqSDOIP4/YFu81_sZmSI/AAAAAAAAB9I/hTbN_7EO65k_4TIHuSfwU2Pvz4aGErr3QCLcBGAsYHQ/s16000/portfolio.webp",
		title: "Portfolio Site",
		desc: "Made a responsive personal portfolio using React and Javascript.",
	},
	{
		url: "https://people-u-admire.netlify.app/",
		githubUrl: "https://github.com/saumya66/PeopleUAdmire",
		thumbNail: "https://miro.medium.com/max/656/0*LJRgrBdPqBJvh8fe",
		title: "People U Admire",
		desc: "Created PeopleUAdmire a Full Stack Responsive WebApp using MongoDB, ExpressJS, React, React-Redux and NodeJS, used by 100s of people.",
	},
];

export default projects;
